import React from 'react';
import { Box, alpha, CardHeader, CardContent } from '@mui/material';
import { COLORS, ModernCard } from '../../../../pages/Organisation/DailyUpdates/utils';

const VerifierSkeleton = () => {
	return (
		<Box
			sx={{
				p: 3,
				maxWidth: '1400px',
				margin: '0 auto',
				backgroundColor: alpha(COLORS.neutral, 0.5),
				borderRadius: '24px'
			}}
		>
			{/* Stats Overview Cards Skeleton */}
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				{/* New Verification Requests Skeleton */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
					</CardHeader>
					<CardContent sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Box
							sx={{
								width: '40px',
								height: '24px',
								bgcolor: COLORS.neutralDark,
								borderRadius: '6px'
							}}
						/>
					</CardContent>
				</ModernCard>

				{/* Pending Verification Requests Skeleton */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Box sx={{ width: '60%', height: '24px', bgcolor: COLORS.neutralDark, borderRadius: 1 }} />
					</CardHeader>
					<CardContent sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Box
							sx={{
								width: '40px',
								height: '24px',
								bgcolor: COLORS.neutralDark,
								borderRadius: '6px'
							}}
						/>
					</CardContent>
				</ModernCard>
			</Box>
		</Box>
	);
};

export default VerifierSkeleton;
